import React from "react";
import { icons } from "icons";
import {
    RenderCurrency,
    RenderNumber,
} from "Utils/renderField/renderReadField";
import NumberFormat from "react-number-format";

export function formatoAcciones(props) {
    return (cell, row) => {
        if (row.existe_descontable || props.conf_cotizacion)
            return (
                <div className="w-100 d-flex align-items-center justify-content-center">
                    <button
                        className="btn btn-agregar-venta"
                        onClick={() => {
                            console.log("Producto a ver detalle:", row); 
                            props.openModalProducto(row);
                        }}
                    >
                        <img
                            className="icon-img m-0"
                            src={icons.ver}
                            alt="Detalle"
                        />
                    </button>
                    <button
                        className="btn btn-agregar-venta"
                        onClick={() => {
                            props.agregar(row);
                            // props.seleccionarProducto(row);
                            props.cambioBuscador();
                        }}
                    >
                        <img
                            className="icon-img m-0"
                            src={icons.carreta}
                            alt="Agregar"
                        />
                    </button>
                </div>
            );
        return <div className="rojo">Existencias agotadas</div>;
    };
}

export function formatoPrecio(cell, row) {
    return <RenderCurrency value={row.precio} />;
}

export function formatoPrecio3Decimales(cell, row) {
    return <RenderCurrency value={row.precio} decimalScale={3} />;
}

export function formatoExistencias(cell, row) {
    return (
        <RenderNumber
            value={row.inventario_calculado}
            decimalScale={row.producto.a_granel ? 3 : 2}
        />
    );
}

export function formatoExistenciasFraccion(cell, row) {
    const valor = row.inventario_calculado;
    const mostrarFraccion = decimalAFraccionMixta(valor);
    return <span>{mostrarFraccion}</span>;
}


function decimalAFraccionMixta(decimal) {
    const tolerancia = 1.0E-6;
    const umbralRedondeo = 0.01; // Redondear fracciones menores a este valor a 0
    const denominadoresComunes = [2, 3, 4, 5, 6, 8, 10]; // Conjunto de denominadores comunes
    const signo = decimal < 0 ? -1 : 1;
    decimal = Math.abs(decimal);

    const entero = Math.floor(decimal);
    let frac = decimal - entero;

    if (frac < tolerancia || frac < umbralRedondeo) return `${signo * entero}`; // Redondear a entero si la fracción es muy pequeña

    // Aproximar la fracción al denominador más cercano en el conjunto de denominadores comunes
    let mejorNumerador = 0;
    let mejorDenominador = 1;
    let mejorDiferencia = 1; // Inicialmente, la diferencia más grande posible

    denominadoresComunes.forEach((den) => {
        const num = Math.round(frac * den);
        const diferencia = Math.abs(frac - num / den);
        if (diferencia < mejorDiferencia) {
            mejorNumerador = num;
            mejorDenominador = den;
            mejorDiferencia = diferencia;
        }
    });

    // Si la fracción simplificada es 0, devolver solo la parte entera
    if (mejorNumerador === 0) return `${signo * entero}`;

    // Construir la fracción simplificada
    if (entero === 0) {
        return `${signo * mejorNumerador}/${mejorDenominador}`;
    } else {
        return `${signo * entero} ${mejorNumerador}/${mejorDenominador}`;
    }
}


export function formatoTotalBaja(props) {
    return (cell, producto) => {
        return (
            <div>
                <NumberFormat
                    className="form-control"
                    placeholder="0"
                    decimalScale={2}
                    fixedDecimalScale={false}
                    value={producto.baja}
                    thousandSeparator={true}
                    prefix={""}
                    onValueChange={(values) => {
                        props.asignarBaja(producto, values.value);
                    }}
                />
            </div>
        );
    };
}
